import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation, useParams, useSearchParams } from "react-router-dom";
import Sidebar from "../../component/sidebar/sidebar";
import Layout from "../../component/layout/layout";
import style from "./AddSeries.module.css";
import { MdLocalMovies } from "react-icons/md";
import {
  addNewSeries,
  seriesUpdate,
  addContentToCategory,
  removeContentFromCategory,
  SeriesShowApi,
  GenresList,
  categoriesList,
  MovieDataList,
  moviesUpdate,
  prefillSeriesListApi,
  prefillSeasonListApi,
  updateTableData,
  liveChannelCreate,
  getEventType,
  getStreamType,
  getLiveChannelDetails,
  putLiveChannelUpdate,
  adminContent,
} from "../../api/HttpApis";
import { IoAdd } from "react-icons/io5";
import { FaCopy } from "react-icons/fa";
import useCommonRating from "../../component/apiCall/RatingandGenre";
import { showToast } from "../../utils/Toastify/Toastify";
import Button from "../../component/button/Button";
import BasicInformation from "../../component/Information/BasicInformation";
import MediaAssets from "../../component/Information/MediaAssests";
import CastCrewMembers from "../../component/Information/CastCrewMembers";
import Technical from "../../component/Information/Technical";
import Publishing from "../../component/Information/Publishing";
import ContentRightsConfirmation, { isCreator, CONTENT_RIGHTS_ERROR } from "../../component/Information/ContentRightsConfirmation";
import {appendPublishingPayload, mapPublishingFromApi, placementPairKey, validateCategoryPlacements} from "../../component/Information/PublishingPayload";
import useCategoryPlacements from "../../hooks/useCategoryPlacements";
import SkeletonLoader from "../../component/skeletonLoader/SkeletonLoader";
import { toSeriesRef } from "../../utils/contentRef";

const AddSeries = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { ratingOptions, accessOptions } = useCommonRating();
  const stateEditData = location.state?.seriesData;
  const { id } = useParams();
  const params = useParams();
  const [searchParams] = useSearchParams();
  const {
    movieId,
    name,
    seriesId,
    seasonId,
    nextEpisodeNumber,
    metadata_id,
    live_type,
    mediaLibrary,
    episode,
  } = location.state || {};
  const { state } = useLocation();

  const [loading, setLoading] = useState(false);
  const [imagePreviewURL, setImagePreviewURL] = useState(null);
  const portraitInputRef = useRef();
  // Experience-Builder placements as returned by GET /series/:id (see handleSubmit)
  const loadedPlacementsRef = useRef([]);
  const landscapeInputRef = useRef();
  const [bannerPreviewURL, setBannerPreviewURL] = useState(null);
  const [genresDataList, setGenresDataList] = useState();
  const [isPortraitUploaded, setIsPortraitUploaded] = useState(false);
  const [isLandscapeUploaded, setIsLandscapeUploaded] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [activeImageType, setActiveImageType] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [movieData, setMovieData] = useState(null);
  const [seriesList, setSeriesList] = useState([]);
  const [seasonList, setSeasonList] = useState([]);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [categoriesData, setCategoriesData] = useState();
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [castList, setCastList] = useState([]);
  const [crewList, setCrewList] = useState([]);
  const [video, setVideo] = useState();
  const [trailer, setTrailer] = useState();
  const [streamData, setStreamData] = useState();
  const [eventData, setEventData] = useState();
  const [progress, setProgress] = useState(0);
  const [activeAccordion, setActiveAccordion] = useState("media");

  // ── Upload success message flag ──
  const [userUploadedMedia, setUserUploadedMedia] = useState(false);

  // ── NEW: hero and logo preview state ──
  const [heroPreviewURL, setHeroPreviewURL] = useState(null);
  const [logoPreviewURL, setLogoPreviewURL] = useState(null);

  // ── Lifted state from Technical ──
  const [technicalData, setTechnicalData] = useState({
    max_quality: "",
    frame_rate: "",
    hdr: "",
    aspect_ratio: "",
    drm: "",
    max_streams: "",
    geo_restrictions: "",
  });

  // ── Lifted state from Publishing ──
  const [publishingData, setPublishingData] = useState({
    access: "",
    access_type: "",
    rent_price: "",
    rent_duration_days: "",
    buy_price: "",
    currency: "",
    status: "",
    publishSpublishing_date: "",
    contentTier: "",
    ppvPrice: "",
    licenseExpiry: "",
    featuredPlacement: "Not Featured",
    featuredUntil: "",
    preferred_orientation: "",
    autoplay_enabled: "",
    category_placements: [],
  });
  // Flips true on the first blocked save so the Publishing accordion can show
  // its Category / Sub Category errors inline instead of only as a toast.
  // Owns the Experience Builder pages and the first Category row. Lives here,
  // not in <Publishing>, because that accordion unmounts while collapsed --
  // a user who never opens it must still get a seeded row and a loaded page
  // list, or the save blocks on a field that was never rendered.
  const {
    sections: loadedSections,
    sectionsError,
    sectionsLoading,
    sectionsComplete,
    showPlacementErrors,
    setShowPlacementErrors,
    ensureRow,
  } = useCategoryPlacements({ setPublishingData });

  // ── Lifted state from CastCrewMembers ──
  const [crewData, setCrewData] = useState({
    directors: "",
    writers: "",
    producers: "",
    composers: "",
  });
  const [castMembers, setCastMembers] = useState([]);
  const [ratingsData, setRatingsData] = useState({
    imdb: "",
    rottenTomatoes: "",
    awards: "",
  });

  // ── NEW: logo file and subtitle files from MediaAssets ──
  const [logoFile, setLogoFile] = useState(null);
  const [subtitleFiles, setSubtitleFiles] = useState([]);
  // Seek-bar preview ("trickplay") thumbnails generated by AI: { vttUrl, spriteUrl, … }.
  // Persisted into the content's other_info on Save so the player can use them.
  const [thumbnailsData, setThumbnailsData] = useState(null);
  // Audio tracks (incl. AI dubs) surfaced from MediaAssets. Each dub row carries a
  // `file` (the .m4a) that must be appended to the save payload as `audio_tracks`
  // (+ audio_tracks_meta), exactly like Mp4FileUpload does — otherwise the dub is
  // generated in the UI but never sent, so it never reaches Bunny/the DB.
  const [audioTracks, setAudioTracks] = useState([]);

  const [rightsConfirmed, setRightsConfirmed] = useState(false);
  const [showRightsError, setShowRightsError] = useState(false);
  const [loadingState, setLoadingState] = useState({
    Publish: false,
    draft: false,
  });

  const selectHlsUrl = JSON.stringify(selectedVideos?.HLSPlaylistURL, null, 2);

  const [formData, setFormData] = useState({
    id: "",
    name: "",
    genres: "",
    year: "",
    rating: "",
    description: "",
    portrait: null,
    landscape: null,
    status: "",
    access: "",
    content_warning: "",
    series_format: "",
  });
  const seriesBannerImage = useRef(null);
  const seriesPortraitImage = useRef(null);
  const isEditing = Boolean(id);

  const OTHER_INFO_KEYS = [
    "url",
    "event_type",
    "processed_HLS_URL",
    "stream_type",
    "liveStatus",
    "start_time",
    "end_time",
    "live_type",
  ];

  const statusData = [
    { id: "Active", name: "Active" },
    { id: "Inactive", name: "Inactive" },
  ];

  const paramsData =
    name === "creator-movie"
      ? "Movie"
      : name === "movie"
        ? "Movie"
        : name === "podcasts"
          ? "Podcast"
          : name === "short-clips"
            ? "Short Clip"
            : name === "series"
              ? "Series"
              : name === "episodes"
                ? "Series"
                : name === "live-streams"
                  ? "Live Stream"
                  : name === "Live Channels"
                    ? "Live Channel"
                    : name === "Live Events"
                      ? "Live Event"
                      : null;

  const soloProps = {
    activeId: activeAccordion,
    setActiveId: setActiveAccordion,
  };

  const isFilled = (...fields) => fields.every(Boolean);

  const handleCastCrewChange = (cast, crew) => {
    setCastList(cast);
    setCrewList(crew);
  };

  if (loadingState.Publish === true || loadingState.draft === true) {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 99) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 30);
  }

  const toDateOnly = (isoString) => {
    if (!isoString) return "";
    return isoString.slice(0, 10);
  };
  const fetchStreamData = async () => {
    try {
      const response = await getStreamType();
      const formattedData = response?.data?.data?.map((item) => ({
        id: item.id,
        name: item.name.toLowerCase(),
      }));
      setStreamData(formattedData || []);
    } catch (error) {
      showToast(error.response.data.message, "error");
    }
  };

  const fetchEventType = async () => {
    try {
      const response = await getEventType();
      const formattedData = response?.data?.data?.map((item) => ({
        id: item.id,
        name: item.name.toLowerCase(),
      }));
      setEventData(formattedData || []);
    } catch (error) {
      showToast(error.response.data.message, "error");
    }
  };

  const toDateTimeLocalNoTZ = (utcTime) => {
    if (!utcTime) return "";
    return utcTime.replace("Z", "").slice(0, 16);
  };

  const handleCopy = () => {
    const vid = Array.isArray(selectedVideos) ? selectedVideos[0] : selectedVideos;
    const url = vid?.HLSPlaylistURL || movieData?.HLSPlaylistURL;
    if (url) {
      navigator.clipboard
        .writeText(url)
        .then(() => { showToast("URL copied to clipboard!", "success"); })
        .catch(() => { showToast("Failed to copy!", "error"); });
    } else {
      showToast("No playlist URL found", "error");
    }
  };

  const handleAdvanced = () => {
    setShowAdvanced(!showAdvanced);
  };

  const handleSelectVideos = (item) => {
    if (activeImageType === "video") {
      setVideo(item);
    } else if (activeImageType === "hero") {
      setHeroPreviewURL(item);
    } else {
      setSelectedVideos(item);
    }
  };

  useEffect(() => {
    fetchStreamData();
    fetchEventType();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        if (isEditing) {
          const apiId = id || params?.id;
          if (!apiId) {
            showToast("Error: Missing Series ID for editing", "error");
            return;
          }
          response = await SeriesShowApi(apiId);
        }

        const data = response?.data?.data;
        if (!data) return;

        setMovieData(data);

        if (data.title_logo_url) {
          setLogoPreviewURL(data.title_logo_url);
        }

        if (data.preview_url) {
          setHeroPreviewURL(data.preview_url);
        }

        setFormData((prev) => ({
          ...prev,
          id: data.id ?? prev.id,
          name: data.name ?? prev.name,
          tagline: data.tagline ?? prev.tagline,
          description: data.description ?? prev.description,
          genres:
            Array.isArray(data.genres) && data.genres.length > 0
              ? data.genres.join(",")
              : data.genres ?? prev.genres,
          rating: data.rating ?? prev.rating,
          access: data.access ?? prev.access,
          year: data.year ?? prev.year,
          portrait: data.portrait ?? prev.portrait,
          landscape: data.landscape ?? prev.landscape,
          language: data.language ?? prev.language,
          country: data.country ?? prev.country,
          studio: data.studio ?? prev.studio,
          imdb_id: data.imdb_id ?? prev.imdb_id,
          release_date: toDateOnly(data.release_date) ?? prev.release_date,
          content_warning: data.content_warning ?? prev.content_warning,
          badges: data.badge ?? prev.badges,
          drm: data.drm ?? prev.drm,
          status: data.status ?? prev.status,
          series_format: data.series_format ?? prev.series_format,
        }));

        // Placements as loaded, so a save can take the series back out of any
        // category the admin removed from the Publishing form.
        loadedPlacementsRef.current = Array.isArray(data.requested_placements)
          ? data.requested_placements
          : [];

        setPublishingData((prev) => ({
          ...prev,
          status: data.status ?? prev.status,
          contentTier: data.access ?? prev.contentTier,
          ...mapPublishingFromApi(data, prev),
          publishing_date: data.publishing_date ?? prev.publishing_date,
          preferred_orientation: data.preferred_orientation ?? prev.preferred_orientation,
          autoplay_enabled:
            data.autoplay_enabled !== null && data.autoplay_enabled !== undefined
              ? String(data.autoplay_enabled)
              : prev.autoplay_enabled,
        }));
        setTechnicalData((prev) => ({
          ...prev,
          drm: data.drm !== null && data.drm !== undefined ? data.drm : prev.drm,
        }));

      } catch (error) {
        showToast(error?.response?.data?.message || "Failed to fetch Series data", "error");
      }
    };

    if (isEditing) {
      fetchData();
    }
  }, [id, isEditing, params?.id]);

  useEffect(() => {
    const fetchSeriesList = async () => {
      try {
        if (formData["content-type"] === "Series") {
          const seriesRes = await prefillSeriesListApi();
          const formattedSeries = (seriesRes?.data?.data || []).map((item) => ({
            id: item.id,
            name: item.name || item.title,
          }));
          setSeriesList(formattedSeries);
        } else {
          if (movieData) {
            setFormData((prev) => ({
              ...prev,
              name: movieData.name || "",
              "content-type": movieData["content-type"],
              genres:
                Array.isArray(movieData.genres) && movieData.genres.length > 0
                  ? movieData.genres.join(",")
                  : movieData.genres || "",
              rating: movieData.rating || "",
              access: movieData.access || "",
              description: movieData.description || "",
              portrait: movieData.portrait || null,
              landscape: movieData.landscape || null,
            }));
          }
        }
      } catch (error) {
        showToast("Failed to fetch series list", "error");
      }
    };
    fetchSeriesList();
  }, [movieData]);

  useEffect(() => {
    const fetchSeasonList = async () => {
      if (formData["content-type"] === "Series" && formData.series_id) {
        try {
          const seasonRes = await prefillSeasonListApi(formData.series_id);
          const formattedSeasons = (seasonRes?.data?.data || []).map(
            (item) => ({
              name: item.name,
              season_id: item.season_id || item.id,
            })
          );
          setSeasonList(formattedSeasons);
        } catch (error) {
          showToast("Failed to fetch season list", "error");
        }
      }
    };
    fetchSeasonList();
  }, [formData["content-type"], formData.series_id]);

  useEffect(() => {
    const fetchGenresAndCategories = async () => {
      try {
        const genresResponse = await GenresList();
        const categoriesResponse = await categoriesList();

        let categories = categoriesResponse?.data?.data || [];

        if (mediaLibrary || live_type !== "Channel") {
          categories = categories.filter((item) => item.id !== "live-channels");
        }
        if (episode !== "episode") {
          categories = categories.filter((item) => item.id !== "series");
        }
        setCategoriesData(categories);
        setGenresDataList(genresResponse?.data?.data || []);
      } catch (error) {
        showToast("Failed to load categories or genres", "error");
      }
    };
    fetchGenresAndCategories();
  }, [movieId]);

  useEffect(() => {
    if (formData["content-type"]) {
    }
  }, [formData["content-type"]]);

  useEffect(() => {
    if (movieId && seasonId && seriesId && nextEpisodeNumber) {
      MovieDataList(movieId, seasonId, seriesId, nextEpisodeNumber);
    }
  }, [movieId, seasonId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let response;
        const isEpisode = movieId && seriesId && seasonId && nextEpisode;
        if (isEpisode) {
          const hasMetaFalseParam = searchParams.get("meta") === "false";
          const isUsingFallback = hasMetaFalseParam || !metadata_id;
          const queryParams = isUsingFallback ? { meta: false } : {};
          response = await MovieDataList(movieId, "", queryParams);
          seriesBannerImage.current = response?.data?.landscape;
          seriesPortraitImage.current = response?.data?.portrait;
        } else if (isEditing && name === "Live Channels" && metadata_id) {
          response = await getLiveChannelDetails(metadata_id);
        } else if (isEditing) {
          const apiId = metadata_id || movieId || params?.id;
          if (!apiId) {
            showToast("Error: Missing video ID for editing", "error");
            return;
          }
          const hasMetaFalseParam = searchParams.get("meta") === "false";
          const isUsingFallback = hasMetaFalseParam || !metadata_id;
          const queryParams = isUsingFallback ? { meta: false } : {};
          response = await MovieDataList(apiId, "", queryParams);
        }

        const data = response?.data;
        if (!data) return;

        setMovieData(data);

        const categories = isEpisode
          ? "Series"
          : paramsData
            ? paramsData
            : Array.isArray(data["content-type"]) &&
              data["content-type"].length > 0
              ? data["content-type"][0]
              : data["content-type"] ?? "";

        setFormData((prev) => ({
          ...prev,
          name: data.name ?? prev.name,
          "content-type": categories,
          genres:
            Array.isArray(data.genres) && data.genres.length > 0
              ? data.genres.join(",")
              : data.genres ?? prev.genres,
          rating: data.rating ?? prev.rating,
          access: data.access ?? prev.access,
          description: data.description ?? prev.description,
          series_id: data.series_id ?? prev.series_id,
          season_id: data.season_id ?? prev.season_id,
          episode_number: data.episode_number ?? prev.episode_number,
          portrait: data.portrait ?? prev.portrait,
          landscape: data.landscape ?? prev.landscape,
          release_year: data.release_year ?? prev.release_year,
          language: data.language ?? prev.language,
          live_type: data.other_info?.live_type ?? prev.live_type,
          url: data.other_info?.url ?? prev.url,
          event_type: data.other_info?.event_type ?? prev.event_type,
          processed_HLS_URL:
            data.other_info?.processed_HLS_URL ?? prev.processed_HLS_URL,
          stream_type: data.other_info?.stream_type ?? prev.stream_type,
          liveStatus: data.other_info?.liveStatus ?? prev.liveStatus,
          start_time:
            toDateTimeLocalNoTZ(data.other_info?.start_time) ?? prev.start_time,
          end_time:
            toDateTimeLocalNoTZ(data.other_info?.end_time) ?? prev.end_time,
        }));

        setImagePreviewURL(data.portrait ?? null);
        setBannerPreviewURL(data.landscape ?? null);
      } catch (error) {
        showToast(
          error?.response?.data?.message || "Failed to fetch data",
          "error"
        );
      }
    };

    const nextEpisode = nextEpisodeNumber || location.state?.nextEpisodeNumber;
    const isEpisodeEditing = movieId && seriesId && seasonId && nextEpisode;

    if (isEpisodeEditing ) {
      fetchData();
    }
  }, [movieId, seriesId, seasonId, isEditing, params?.id, nextEpisodeNumber]);

  const handleimagesvalue = (item) => {
    // Only set the flag when the user actively picks/uploads media
    setUserUploadedMedia(true);

    if (activeImageType === "portrait") {
      setIsPortraitUploaded(true);
      setImagePreviewURL(item);
      setFormData((prev) => ({
        ...prev,
        portrait: item.id,
      }));
    } else if (activeImageType === "landscape") {
      setIsLandscapeUploaded(true);
      setBannerPreviewURL(item);
    } else if (activeImageType === "logo") {
      setLogoPreviewURL(item);
      setFormData((prev) => ({ ...prev, logo: item.id }));
    } else if (activeImageType === "hero") {
      setHeroPreviewURL(item);
    } else if (activeImageType === "video") {
      setVideo(item);
    }
  };

  useEffect(() => {
    return () => {
      if (
        imagePreviewURL &&
        typeof imagePreviewURL === "string" &&
        imagePreviewURL.startsWith("blob:")
      ) {
        URL.revokeObjectURL(imagePreviewURL);
      }
      if (
        bannerPreviewURL &&
        typeof bannerPreviewURL === "string" &&
        bannerPreviewURL.startsWith("blob:")
      ) {
        URL.revokeObjectURL(bannerPreviewURL);
      }
    };
  }, [imagePreviewURL, bannerPreviewURL]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;

    if (name === "portrait" && files?.length > 0) {
      const imageFile = files[0];
      setFormData((prev) => ({
        ...prev,
        portrait: imageFile,
      }));
      setIsPortraitUploaded(true);
      setImagePreviewURL(URL.createObjectURL(imageFile));
      return;
    }

    if (name === "landscape" && files?.length > 0) {
      const imageFile = files[0];
      setFormData((prev) => ({
        ...prev,
        landscape: imageFile,
      }));
      setIsLandscapeUploaded(true);
      setBannerPreviewURL(URL.createObjectURL(imageFile));
      return;
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleIconClick = (type) => {
    setActiveImageType(type);
    setIsOpen(true);
    if (type === "portrait") {
      // portraitInputRef.current.click();
    } else if (type === "landscape") {
      // landscapeInputRef.current.click();
    }
  };

const handleSubmit = async (e, type, buttonType) => {
    e.preventDefault();

    if (isCreator() && !rightsConfirmed) {
      setShowRightsError(true);
      showToast(CONTENT_RIGHTS_ERROR, "error");
      return;
    }

    if (!formData.name) {
      showToast("Name is required", "error");
      return;
    }

    // Category / Sub Category is mandatory for Save Draft as well as Publish.
    // The Series form always renders the field, so it always applies here.
    const placementError = validateCategoryPlacements(publishingData, loadedSections, {
      sectionsComplete,
    });
    if (placementError) {
      setShowPlacementErrors(true);
      // The Publishing accordion starts collapsed and unmounts its body, so
      // without this the user gets a toast about a field that isn't on screen
      // and nothing visibly changes.
      ensureRow();
      setActiveAccordion("publishing");
      showToast(placementError, "error");
      return;
    }
    setShowPlacementErrors(false);

    const payload = new FormData();

    /* IMAGES */
    const portraitValue =
      (formData.portrait instanceof File ? formData.portrait : null) ||
      imagePreviewURL?.bunny_cdn_url ||
      imagePreviewURL?.id ||
      (typeof imagePreviewURL === "string" && !imagePreviewURL.startsWith("blob:")
        ? imagePreviewURL
        : "") ||
      seriesPortraitImage.current ||
      stateEditData?.portrait ||
      movieData?.portrait ||
      "";
    payload.append("portrait", portraitValue);

    const landscapeValue =
      (formData.landscape instanceof File ? formData.landscape : null) ||
      bannerPreviewURL?.bunny_cdn_url ||
      bannerPreviewURL?.id ||
      (typeof bannerPreviewURL === "string" && !bannerPreviewURL.startsWith("blob:")
        ? bannerPreviewURL
        : "") ||
      seriesBannerImage.current ||
      stateEditData?.landscape ||
      movieData?.landscape ||
      "";
    payload.append("landscape", landscapeValue);

    // payload.append("status", type);

    /* MEDIA */
    if (trailer?.url || trailer?.bunny_cdn_url || movieData?.trailer?.url) {
      payload.append(
        "trailer",
        trailer?.url || trailer?.bunny_cdn_url || movieData?.trailer?.url || ""
      );
    }

    /* VIDEO — always send key */
    payload.append("video", video?.id || "");

    /* CAST & CREW */
    const castsPayload = (castMembers || [])
      .filter((c) => c.type === "Cast" && c.actorId)
      .map((c) => ({
        member_id: c.actorId,
        role: c.role || "ACTOR",
        character_name: c.character || "",
      }));
    const crewsPayload = (castMembers || [])
      .filter((c) => c.type === "Crew" && c.actorId)
      .flatMap((c) => {
        const roles = Array.isArray(c.role) ? c.role : c.role ? [c.role] : [];
        return roles.map((r) => ({ member_id: c.actorId, role: r }));
      });
    payload.append("casts", JSON.stringify(castsPayload));
    payload.append("crews", JSON.stringify(crewsPayload));

    /* SUBTITLES */
    const subtitlesMeta = [];

    /* LOGO — always send key */
      const logoUrl =
      logoPreviewURL    // will be null after removal
        ? (logoPreviewURL?.title_logo_url || logoPreviewURL?.bunny_cdn_url ||
          logoPreviewURL?.url || (typeof logoPreviewURL === "string" ? logoPreviewURL : null) ||
        movieData?.title_logo_url || "")
        : "";           // cleared — send empty string
    payload.append("title_logo_url", logoUrl);

    const heroUrl =
      heroPreviewURL  
        ? (heroPreviewURL?.preview_url || heroPreviewURL?.bunny_cdn_url ||
          heroPreviewURL?.HLSPlaylistURL || (typeof heroPreviewURL === "string" ? heroPreviewURL : null) ||
          movieData?.preview_url || "")
        : "";         
    payload.append("preview_url", heroUrl);

    // Seek-bar preview (trickplay) thumbnails — stored in other_info by the backend
    // for any content type. Prefer a freshly generated set, else keep whatever the
    // content already had so a save doesn't wipe existing previews.
    const thumbVtt =
      thumbnailsData?.vttUrl || movieData?.other_info?.thumbnails_vtt_url || "";
    const thumbSprite =
      thumbnailsData?.spriteUrl || movieData?.other_info?.thumbnails_sprite_url || "";
    if (thumbVtt) payload.append("thumbnails_vtt_url", thumbVtt);
    if (thumbSprite) payload.append("thumbnails_sprite_url", thumbSprite);

    /* AUDIO TRACKS (incl. AI dubs) — mirrors Mp4FileUpload. A track carrying a
       `file` (an AI dub .m4a) is uploaded under `audio_tracks`, described in the
       parallel `audio_tracks_meta` JSON (index-aligned to the files). Existing saved
       rows (numeric id) are preserved via `audio_tracks_keep_ids`. Without this the
       dub is generated + shown in the UI but never sent on Save. */
    const audioMeta = [];
    const audioFilesArray = [];
    const keptAudioIds = [];
    (audioTracks || []).forEach((track) => {
      if (!track) return;
      if (track.id != null && String(track.id).match(/^\d+$/)) {
        keptAudioIds.push(parseInt(track.id, 10));
        return;
      }
      const audioLang = track.languageCode || track.language || "";
      const audioBase = {
        language: audioLang,
        label: track.label || "",
        format: track.format || (track.file ? "m4a" : ""),
        dubbed: Boolean(track.dubbed),
        voice: track.voice || "",
      };
      if (track.file) {
        audioFilesArray.push(track.file);
        audioMeta.push({ ...audioBase, hasFile: true });
      } else {
        audioMeta.push({ ...audioBase, hasFile: false });
      }
    });
    audioFilesArray.forEach((file) => payload.append("audio_tracks", file));
    payload.append("audio_tracks_meta", JSON.stringify(audioMeta));
    payload.append("audio_tracks_keep_ids", JSON.stringify(keptAudioIds));

    if (metadata_id) payload.append("metadata_id", metadata_id);

    /* BASIC INFO FIELDS — always send key, empty string if no value */
    const BASIC_INFO_KEYS = [
      "description", "year", "release_date", "language", "country",
      "tagline", "studio", "imdb_id", "duration",
      "content_warning", "rating",
    ];

    for (const key of BASIC_INFO_KEYS) {
      const val = formData[key];
      const isEmpty = val === null || val === undefined || val === "" || String(val) === "undefined";
      payload.append(key, isEmpty ? "" : val);
    }

    // name — always send, empty if no value
    const nameVal = formData["name"];
    const nameIsEmpty = nameVal === null || nameVal === undefined || nameVal === "" || String(nameVal) === "undefined";
    payload.append("name", nameIsEmpty ? "" : nameVal);

    /* REMAINING formData — skip keys already handled */
    const ALREADY_HANDLED = new Set([
      ...BASIC_INFO_KEYS,
      "name", "status", "portrait", "landscape",
      "genres", "badges", "logo", "drm", "access", "content_warnings", "content-type",
      ...OTHER_INFO_KEYS,
    ]);

    for (const key in formData) {
      if (ALREADY_HANDLED.has(key)) continue;
      if (
        formData[key] === null || formData[key] === "" || formData[key] === undefined ||
        String(formData[key]) === "undefined"
      ) continue;
      if (key === "content-type") {
        payload.append(
          "content-type",
          formData["content-type"] === "Video"
            ? categoriesData?.[0]?.name || ""
            : formData["content-type"]
        );
      } else {
        payload.append(key, formData[key]);
      }
    }

    /* GENRES */
    if (formData.genres) {
      const selectedGenreNames = Array.isArray(formData.genres)
        ? formData.genres
        : formData.genres.split(",").map((g) => g.trim()).filter(Boolean);
      const genreIds = selectedGenreNames
        .map((name) => {
          const match = genresDataList?.find((g) => g.name.toLowerCase() === name.toLowerCase());
          return match ? match.id : null;
        })
        .filter((id) => id !== null);
      payload.append("genre_ids", JSON.stringify(genreIds));
    }

    /* BADGE — always send key */
    const badgeValue = formData.badges
      ? (Array.isArray(formData.badges) ? formData.badges[0] : formData.badges)
      : "";
    payload.append("badge", String(badgeValue));

    /* TECHNICAL — always send all keys */
    payload.append("drm", technicalData.drm || "");
    payload.append("geo_restrictions", technicalData.geo_restrictions || "");

    /* PUBLISHING — always send all keys */
    payload.append("publishing_date", publishingData.publishing_date || "");
    payload.append("preferred_orientation", publishingData.preferred_orientation || "");
    payload.append("autoplay_enabled", String(publishingData.autoplay_enabled ?? ""));
    appendPublishingPayload(payload, publishingData);

    /* CREW — always send all keys */
    payload.append("producers", crewData.producers || "");
    payload.append("composers", crewData.composers || "");

    /* RATINGS — always send all keys */
    payload.append("imdb_rating", ratingsData.imdb || "");

    setLoadingState((prev) => ({ ...prev, [buttonType]: true }));

    try {
      setLoading(true);
      let response;
      if (isEditing) {
        response = await seriesUpdate(id, payload);
        showToast("Series updated successfully!", "success");
      } else {
        response = await addNewSeries(payload);
        showToast("Series added successfully!", "success");
      }

      // Best-effort: assign this series into each selected Experience Builder
      // category. Failure here shouldn't block the save that already succeeded.
      const placements = Array.isArray(publishingData?.category_placements)
        ? publishingData.category_placements.filter((p) => p.section_id && p.category_id)
        : [];
      const seriesId = isEditing ? id : response?.data?.data?.id;
      if (seriesId) {
        for (const placement of placements) {
          try {
            await addContentToCategory(parseInt(placement.section_id, 10), parseInt(placement.category_id, 10), toSeriesRef(parseInt(seriesId, 10)));
          } catch (categoryError) {
            console.error("Error assigning series to category:", categoryError);
          }
        }

        // Keyed on the section+category PAIR, matching placementPairKey used
        // everywhere else in this feature. Keying on category_id alone meant a
        // series placed in the same category on two different pages kept both
        // rows when only one was removed.
        const keptPairs = new Set(placements.map((p) => placementPairKey(p)));
        const removedPlacements = isEditing
          ? loadedPlacementsRef.current.filter((p) => !keptPairs.has(placementPairKey(p)))
          : [];
        for (const placement of removedPlacements) {
          try {
            await removeContentFromCategory(
              placement.section_id,
              placement.category_id,
              placement.content_ref ?? toSeriesRef(parseInt(seriesId, 10))
            );
          } catch (categoryError) {
            console.error("Error removing series from category:", categoryError);
          }
        }
      }

      navigate("/mainlayout/series");
    } catch (error) {
      const response = error?.response?.data;
      if (response?.errors) {
        const fieldErrors = Object.values(response.errors).flat();
        if (fieldErrors.length > 0) {
          showToast(fieldErrors[0], "error");
        } else if (response.message) {
          showToast(response.message, "error");
        }
      } else if (response?.message) {
        showToast(response.message, "error");
      }
    } finally {
      setLoadingState((prev) => ({ ...prev, [buttonType]: false }));
      setLoading(false);
    }
  };

  useEffect(() => {
    const getGenresList = async () => {
      const response = await GenresList();
      setGenresDataList(response?.data?.data || []);
    };
    getGenresList();
  }, []);

  useEffect(() => {
    return () => {
      if (imagePreviewURL) URL.revokeObjectURL(imagePreviewURL);
      if (bannerPreviewURL) URL.revokeObjectURL(bannerPreviewURL);
    };
  }, [imagePreviewURL, bannerPreviewURL]);

  const yearOptions = Array.from(
    { length: new Date().getFullYear() - 1900 + 1 },
    (_, i) => {
      const y = new Date().getFullYear() - i;
      return { id: String(y), name: String(y) };
    }
  );

  useEffect(() => {
    if (movieData) {
      if (movieData.portrait && !isPortraitUploaded) {
        setImagePreviewURL(movieData.portrait);
      }
      if (movieData.landscape && !isLandscapeUploaded) {
        setBannerPreviewURL(movieData.landscape);
      }
      if (movieData.casts && Array.isArray(movieData.casts)) {
        setCastList(movieData.casts);
      } else {
        setCastList([]);
      }
      if (movieData.crews && Array.isArray(movieData.crews)) {
        setCrewList(movieData.crews);
      } else {
        setCrewList([]);
      }
    }
  }, [movieData, isPortraitUploaded, isLandscapeUploaded]);

  useEffect(() => {
    if (movieData?.trailer && !trailer) {
      setTrailer(movieData.trailer);
    }
  }, [movieData?.trailer, trailer]);

  useEffect(() => {
    if (movieData?.video && !video) {
      setVideo(movieData.video);
    }
  }, [movieData?.video, video]);

  return (
    <>
      <div className={style.mainContainer}>
        <Sidebar />
        <Layout>
          <div className={style.innerContainer}>

            {/* ─── LEFT SIDE ─── */}
            <div className={style.leftContainer}>

              
              <MediaAssets
                formData={formData}
                handleChange={handleChange}
                handleIconClick={handleIconClick}
                isLandscapeUploaded={isLandscapeUploaded}
                isPortraitUploaded={isPortraitUploaded}
                bannerPreviewURL={bannerPreviewURL}
                imagePreviewURL={imagePreviewURL}
                isOpen={isOpen}
                setIsOpen={setIsOpen}
                setSelectedVideos={handleSelectVideos}
                handleimagesvalue={handleimagesvalue}
                setIsPortraitUploaded={setIsPortraitUploaded}
                selectedImage={selectedImage}
                setSelectedImage={setSelectedImage}
                portraitInputRef={portraitInputRef}
                handleAdvanced={handleAdvanced}
                showAdvanced={showAdvanced}
                movieData={movieData}
                handleCastCrewChange={handleCastCrewChange}
                selectedVideos={selectedVideos}
                setTrailer={setTrailer}
                setVideo={setVideo}
                video={video}
                name={name}
                soloProps={soloProps}
                onSubtitleChange={setSubtitleFiles}
                onLogoChange={setLogoFile}
                heroPreviewURL={heroPreviewURL}
                logoPreviewURL={logoPreviewURL}
                 onLogoRemove={() => setLogoPreviewURL(null)}
                onHeroRemove={() => setHeroPreviewURL(null)}
                onThumbnailsChange={setThumbnailsData}
                thumbnailsVtt={
                  thumbnailsData?.vttUrl || movieData?.other_info?.thumbnails_vtt_url || null
                }
                audioTracks={audioTracks}
                onAudioTracksChange={setAudioTracks}
              />
              <BasicInformation
                formData={formData}
                handleChange={handleChange}
                isEditing={isEditing}
                categoriesData={categoriesData}
                seriesList={seriesList}
                seasonList={seasonList}
                genresDataList={genresDataList}
                ratingOptions={ratingOptions}
                accessOptions={accessOptions}
                eventData={eventData}
                streamData={streamData}
                statusData={statusData}
                mediaLibrary={mediaLibrary}
                soloProps={soloProps}
                isSeries={true}
              />
              <Technical
                soloProps={soloProps}
                formData={formData}
                handleChange={handleChange}
                technicalData={technicalData}
                setTechnicalData={setTechnicalData}
              />
              <Publishing
                soloProps={soloProps}
                publishingData={publishingData}
                setPublishingData={setPublishingData}
                isSeries={true}
                showPlacementErrors={showPlacementErrors}
                sections={loadedSections}
                sectionsError={sectionsError}
                sectionsLoading={sectionsLoading}
              />

              {/* ─── BUTTON SECTION ─── */}
              <ContentRightsConfirmation
                checked={rightsConfirmed}
                onChange={(v) => {
                  setRightsConfirmed(v);
                  if (v) setShowRightsError(false);
                }}
                showError={showRightsError}
              />

              <div className={style.buttonWrapper}>
                <div className={style.readyToGoLiveBanner}>
                  <div className={style.readyToGoLiveLeft}>
                    <span className={style.readyToGoLiveTitle}>Ready To Go Live?</span>
                    <span className={style.readyToGoLiveMeta}>
                      {formData.name}
                    </span>
                  </div>
                  <div className={style.btnBox}>
                    <Button
                      className={style.publishNowBtn}
                      onClick={(e) => handleSubmit(e, publishingData.status, "Publish")}
                      loading={loadingState.Publish}
                    >
                      Save Changes
                    </Button>
                  </div>
                </div>
              </div>
              {/* ─── END BUTTON SECTION ─── */}

            </div>
            {/* ─── END LEFT SIDE ─── */}

          </div>
        </Layout>
      </div>
    </>
  );
};

export default AddSeries;